module.exports = "<div class=\"Video\" style=\"position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto;\">\n  <iframe ng-src=\"{{::ctrl.getSrc()}}\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/common/slideshow/slideshow_video.html
// module id = 109
// module chunks = 24